import { memo } from 'react';
import { CopyString, ParagraphWithTooltip } from 'components';
import { subdirectory } from 'utils';
import { CampaignStatusAction } from './CampaignStatusAction';
import * as S from './MetricCardRow.styled';

export const MetricCardRow = memo(
  ({ type, data, metric, eventPercentValue, showProgressBar, progressValue = 0 }) => {
    const trend = type === 'Top Events' ? data.trend : data.trends?.[metric];

    return (
      <S.Wrap showProgressBar={showProgressBar}>
        {(type === 'Campaigns' || type === 'Events/Installs Ratio') && (
          <CampaignStatusAction campaignId={data.id} status={data.status} />
        )}
        {type !== 'Top Events' && (
          <S.AppIcon
            src={`https://cdn.appnext.com/${subdirectory(data.image_url)}/${data.image_url}`}
          />
        )}
        <S.Info>
          <ParagraphWithTooltip text={data.name} />
          {type !== 'Top Events' && <CopyString label='ID' text={data.id?.toString()} />}
        </S.Info>
        <S.MetricValue>
          {formatMetricValue(metric, data[metric])}
          <S.Trend direction={trend} />
          {type === 'Events/Installs Ratio' && (
            <S.EventValue>{+eventPercentValue.toFixed(2)}%</S.EventValue>
          )}
        </S.MetricValue>
        {showProgressBar && <S.ProgressBar progressValue={progressValue} direction={trend} />}
      </S.Wrap>
    );
  },
);

MetricCardRow.displayName = 'MetricCardRow';

function formatMetricValue(metric, value) {
  const isCurrency = metric === 'cost' || metric === 'revenue' || metric === 'eCPM';
  return isCurrency ? `$${formatNumber(value)}` : formatNumber(value);
}

function formatNumber(value) {
  const numericValue = Number(value) || 0;

  if (numericValue >= 1000) {
    const formatted = (numericValue / 1000).toFixed(2).replace(/\.?0+$/, '');
    return `${formatted}K`;
  }

  return numericValue.toLocaleString();
}
